export { default as VendorLogo } from "./VendorLogo";
